import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { selectIsCms } from "../../../redux/slices/configSlice";
import Submit from "./Submit";

const ConnectedSubmit = ({ controlId }) => {
    const isCms = useSelector(selectIsCms);

    const submitProps = {
        controlId,
        isCms,
    };
    return <Submit {...submitProps} />;
};

ConnectedSubmit.propTypes = {
    controlId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
};

export default ConnectedSubmit;
